import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";

import authReducer from "./auth/redux/reducer";
import activityReducer  from "./activity/redux/reducer";
import costpackageReducer from "./costpackege/redux/reducer";
import vendorReducer from "./vendors/redux/reducer";
import voaReducer from "./voa/redux/reducer";
import voaSummaryReducer from "./voa_summary/redux/reducer";
import cpoReducer from "./sode/cpo/redux/reducer";
import oetReducer from "./sode/oet/redux/reducer";
import oetNonSodeReducer from "./non-sode/oet/redux/reducer";
import neoImporterReducer from "./neo_importer/redux/reducer";
import nonSodeInboxReducer from "./non-sode/inbox/redux/reducer";
import masterBudgetReducer from "./non-sode/master_budget/redux/reducer";
import notificationReducer from "./notification/redux/reducer";
// import bannerReducer from "./banner/redux/reducer";

const composeEnhancer = (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
    combineReducers({
        auth: authReducer,
        activity: activityReducer,
        cpo: cpoReducer,
        oet: oetReducer,
        oet_non_sode: oetNonSodeReducer,
        vendor: vendorReducer,
        costpackage: costpackageReducer,
        neoimporter: neoImporterReducer,
        voa: voaReducer,
        master_budget: masterBudgetReducer,
        voa_summary: voaSummaryReducer,
        non_sode: nonSodeInboxReducer,
        notification: notificationReducer,
        // banner: bannerReducer,
    }),
    composeEnhancer(applyMiddleware(thunk))
);

export default store;
